// reCAPTCHA temporarily disabled.
// Google is deprecating reCAPTCHA v3 (vue-recaptcha-v3) and forcing a migration,
// which surfaced a submission error for clients. Until we migrate to the new
// version, the verification is bypassed: recaptchaCallback() resolves true so the
// public forms (endorsement, petition, contact) submit without a challenge.
//
// To re-enable: restore the imports/Vue.use below and the original recaptchaCallback
// implementation (see git history), then wire up the new reCAPTCHA version.
//
// import Vue from "vue";
// import { VueReCaptcha } from "vue-recaptcha-v3";
// import * as SecurityService from "@/services/SecurityService";
//
// Vue.use(VueReCaptcha, { siteKey: process.env.RECAPTCHA_SITE_KEY });

export default {
  methods: {
    recaptchaCallback() {
      // reCAPTCHA disabled — always report success.
      return Promise.resolve(true);
    }
  }
};
